import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IBlog, IBlogResponse, IPostMonth, IPostMonthsResponse, IPostTag, IPostTagsResponse } from 'src/app/models/dashboard.models';
import { BlogService } from 'src/app/services/blog.service';
import { HomeService } from 'src/app/services/home.service';

@Component({
  selector: 'app-blog-detail',
  templateUrl: './blog-detail.component.html',
  styleUrls: ['./blog-detail.component.scss']
})
export class BlogDetailComponent implements OnInit {

  tags: Array<IPostTag> = [];
  months: Array<IPostMonth> = [];
  blogId : any;
  blog: IBlog;
  recentBlogs: Array<IBlog> = [];
  offset: number = 0;
  limit: number = 3;

  blogLoading: boolean;
  recentBlogLoading: boolean;
  tagLoading: boolean;
  monthLoading: boolean;

  constructor(public blogService: BlogService,
    public homeService: HomeService,
    private _Activatedroute : ActivatedRoute) { }

  ngOnInit(): void {
    this._Activatedroute.paramMap.subscribe(params => { 
      this.blogId = params.get('blogId');
      this.getMidwifeBlog(); 
    });
    this.getRecentBlogs();
    this.getPostTags();
    this.getPostMonths();
  }

  getMidwifeBlog(){
    let body = {
      postId: this.blogId
    };
    this.blogLoading = true;
    this.blogService.getBlogById(body).subscribe((res: IBlogResponse)=>{
      this.blog = res.post;
      console.log("Blog Detail/Blogs:", this.blog);
      this.blogLoading = false;
    },err=>{
      console.error("Blog Detail Error:", err);
      this.blogLoading = false;
    });
  }

  getRecentBlogs(){
    this.recentBlogLoading = true;
    this.homeService.getRecentBlogs(this.limit, this.offset)
    .subscribe((res)=>{
      this.recentBlogs = res.payload;
      console.log("Blog Detail/Recent Blogs: ", this.recentBlogs);
      this.recentBlogLoading = false;
    },err=>{
      console.error("Blog Detail/Recent Blogs Error: ", err);
      this.recentBlogLoading = false;
    });
  }

  getPostTags(){
    this.tagLoading = true;
    this.blogService.getBlogPostTags().subscribe((res: IPostTagsResponse)=>{
      this.tags = res.payload;
      console.log("Tags:", this.tags);
      this.tagLoading = false;
    },err=>{
      console.error("Tags Error:", err);
      this.tagLoading = false;
    });
  }

  getPostMonths(){
    this.monthLoading = true;
    this.blogService.getBlogPostMonths().subscribe((res: IPostMonthsResponse)=>{
      this.months = res.payload;
      console.log("Months:", this.tags);
      this.monthLoading = false;
    },err=>{
      console.error("Months Error:", err);
      this.monthLoading = false;
    });
  }
}
